import { useAuth } from '../lib/auth';
import { PortalScene, LoginArtifactCard } from '../components/portal';
import { VersionInfo } from '../components/VersionInfo';

/**
 * Login page with mystic portal scene
 */
export function LoginPage() {
  const { login } = useAuth();

  return (
    <PortalScene>
      <LoginArtifactCard onSubmit={login} />
      {/* Fixed Footer */}
      <div className="fixed bottom-0 left-0 right-0 z-20 bg-gradient-to-t from-void via-void/95 to-transparent pt-6 pb-4">
        <div className="text-center">
          <VersionInfo />
        </div>
      </div>
    </PortalScene>
  );
}
